export default __webpack_public_path__ + "static/Hero_Image_Light-b1ba0daa878fe76f07608d5547b53736.png";